import React, { useState, useEffect } from 'react'
import Layout from '../../../../component/layout/Layout'
import 'aos/dist/aos.css';
import AOS from 'aos';
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import firebaseConfig from '../../../firebase/firebaseConfig';
if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}
const db = firebase.firestore();

const SpWater = () => {
  const [activeSlide, setActiveSlide] = useState(0);

  const handleSlideChange = (index) => {
    setActiveSlide(index);
  };

  const [cards, setCards] = useState([]);

  useEffect(() => {
    AOS.init({ duration: 1000 });

    // Fetch card data ordered by orderID
    const fetchCards = async () => {
      try {
        const snapshot = await db
          .collection("industrialwater_specialitychem")
          .orderBy("orderID", "asc") // Order by 'orderID' in ascending order
          .get();

        const cardData = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setCards(cardData);
      } catch (error) {
        console.error("Error fetching cards: ", error);
      }
    };

    fetchCards();
  }, []);


  return (
    <Layout>
      <div className="bread">
        <ul className="collapsed">
          <li><a href="/specialalitychem">Speciality Chemicals</a></li>
          <li><a href="/">Home</a></li>
        </ul>
      </div>
      <section id="hero">
        <div id="heroCarousel" className="carousel slide carousel-fade" data-bs-interval="5000" data-bs-ride="carousel">
          <ol className="carousel-indicators" id="hero-carousel-indicators">
            <li
              data-bs-target="#heroCarousel"
              data-bs-slide-to="0"
              className={activeSlide === 0 ? "active" : ""}
              onClick={() => handleSlideChange(0)}
            ></li>
          </ol>
          <div className="carousel-inner" role="listbox">
            <div className={`carousel-item ${activeSlide === 0 ? "active" : ""}`} style={{ backgroundImage: "url(/img/water-treatment-1024x520.jpg)" }}>
              <div className="carousel-container">
                <div className="container">
                  <div className="text" id='text'>
                    <h2 className="animate__animated animate__fadeInDown">Industrial Water</h2>
                    <p className="animate__animated animate__fadeInUp">The management of water resources is going to be one of the major challenges we will be facing over the next few decades. Rishabh Metals and Chemicals helps India with more reliable supplies of municipal and industrial water.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="services" className="services">
        <div className="container" data-aos="fade-up">
          <div className="row">
            {cards.map((card, index) => (
              <div
                key={card.id}
                className="col-lg-4 col-md-6"
                data-aos="zoom-in"
                data-aos-delay={100 * (index + 1)}
              >
                <div className="icon-box">
                  <h4>{card.title}</h4>
                  <p>{card.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  )
}

export default SpWater
